import { render, staticRenderFns } from "./Trivia7.vue?vue&type=template&id=79d521a6&scoped=true&"
import script from "./Trivia7.vue?vue&type=script&lang=js&"
export * from "./Trivia7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d521a6",
  null
  
)

export default component.exports